module.exports = __webpack_public_path__ + "static/img/maskBg.ce7d9c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maskBg.png
// module id = zbCz
// module chunks = 1